import React, { memo } from 'react'
import { ChildrenProp } from '../../jsx'
import './Statusbar.scss'

interface Props extends ChildrenProp {}

export const Statusbar = memo(function Statusbar ({ children }: Props) {
  return <div className="statusbar">{children}</div>
})
